module.exports = __webpack_public_path__ + "img/acfss.32d1ddea.png";